import React from "react";

const Item = ({ Links, title, align, disableLink }) => {
  const linkClass = disableLink ? "" : "cursor-pointer";
  return (
    <ul className={`space-y-2 ${align ? 'text-left' : ''}`}>
      <h1 className="mb-1 font-semibold">{title}</h1>
      
      {Links.map((link) => (
        <li key={link.name}>
          <a
            className={`text-white-100 hover:text-teal-400 duration-300 text-sm leading-6 ${linkClass} mb-3 hover:text-teal-400 transition-colors duration-300`}
            href={link.link}
          >
            {link.name}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Item;
